var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.isSecureConnection,"icon":"","x-small":""},on:{"click":_vm.copyToClipboard}},[_c('v-icon',[_vm._v("mdi-content-copy")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }